import type { DropzoneState } from 'react-dropzone';
import gettext from '@sdk/lang/gettext';
import Text14 from '@sdk/components/ui/typography/Text14';
import H5 from '@sdk/components/ui/typography/H5';
import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Tooltip from '@sdk/common/tooltip/Tooltip';
import DropOrBrowseFiles from '@sdk/components/ui/DropOrBrowseFiles/DropOrBrowseFiles';

import InfoSvg from '@web/assets/svg/Icons/16/info-gray.svg';
import ExampleFileSvg from '@web/assets/svg/Misc/example-locations-upload-file.svg';

import { ExampleLabel, ExampleTooltipActivator } from './uploadFile.styles';

type Props = {
  uploadError: string;
  dropzoneState: DropzoneState;
};

const UploadFile = ({ uploadError, dropzoneState }: Props) => {
  return (
    <>
      <Column>
        <H5 themeColor={ThemeColorType.primary}>
          {gettext('Have location data saved in a file?')}
        </H5>
      </Column>
      <Column mTop={10}>
        <Text14 themeColor={ThemeColorType.gray}>
          {gettext(
            "Upload a CSV or Excel file with the location information you have. You'll be able to map data to column labels in the next step."
          )}
        </Text14>
      </Column>
      <ExampleTooltipActivator
        mTop={10}
        alignItems="center"
        data-tip=""
        data-for="locations-import-example-tip">
        <InfoSvg />
        <ExampleLabel semiBold themeColor={ThemeColorType.gray}>
          {gettext('See example')}
        </ExampleLabel>
        <Tooltip
          id="locations-import-example-tip"
          noMaxWidth={true}
          place="right"
          getContent={() => {
            return (
              <Column pTop={10} pBottom={10} pLeft={10} pRight={10}>
                <Text14 themeColor={ThemeColorType.white}>{gettext('Example of the file')}</Text14>
                <Column mTop={20}>
                  <ExampleFileSvg />
                </Column>
              </Column>
            );
          }}
        />
      </ExampleTooltipActivator>
      <Row mTop={20}>
        <DropOrBrowseFiles dropzoneState={dropzoneState} />
      </Row>
      {Boolean(uploadError) && (
        <Row mTop={10}>
          <Text14 themeColor={ThemeColorType.danger}>{uploadError}</Text14>
        </Row>
      )}
    </>
  );
};

export default UploadFile;
